import { ComboboxItem } from '@node-space/ui-components'
import { AllowedCountry, Country } from 'types/authentication/Profile'

export const isValidPercentage = (value: string): boolean => {
  const percentage = parseInt(value)
  if (isNaN(percentage)) return false
  if (percentage < 1 || percentage > 100) return false
  return true
}

export const getCountryOptions = (countries: AllowedCountry[] | Country[]): ComboboxItem[] =>
  countries?.map(({ name, code }) => ({
    leftText: name,
    value: code,
  }))

export const getFormObject = <FormKeyType extends string, ReturnType>(
  formKeys: FormKeyType[],
  mappingFn: (key: FormKeyType) => ReturnType
) => {
  return formKeys?.reduce(
    (object, key) => {
      object[key] = mappingFn(key)
      return object
    },
    {} as Record<FormKeyType, ReturnType>
  )
}
